import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullscreenModalPage } from './fullscreen-modal.page';

const routes: Routes = [
  {
    path: '',
    component: FullscreenModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FullscreenModalPageRoutingModule {}
